import termsApi from "../../api/terms";

export default {
  namespaced: true,

  state: {
    terms: [],
    reload: false
  },

  mutations: {
    SET_TERMS(state, payload) {
      console.log("Setting payload");
      state.terms = payload;
    },
    TOGGLE_REFRESH(state) {
      console.log("Refresh requested");
      state.reload = !state.reload;
    }
  },

  actions: {
    toggleRefresh(context) {
      context.commit("TOGGLE_REFRESH");
    },
    getCurrentAndFutureTerms(context) {
      return termsApi
        .getCurrentAndFutureTerms()
        .then(response => {
          console.log("received terms");
          context.commit("SET_TERMS", response.data);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {});
    },
    getTermsActive(context) {
      return termsApi
        .getTermsActive()
        .then(response => {
          console.log("received terms");
          context.commit("SET_TERMS", response.data);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {});
    },
    getPastTerms(context) {
      return termsApi
        .getPastTerms()
        .then(response => {
          console.log("received terms");
          context.commit("SET_TERMS", response.data);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {});
    }
  }
};
